import { lowerCase } from 'lodash';

const addPartition = (partitions, key, { capacity, unit }, usedPercentage) => {
    return partitions[key] = {
        capacity,
        unit,
        usedPercentage
    };
};

const parseUsedPercentage = percentage => +percentage.slice(0, -1);

const parseCapacity = capacity => {
    const splitedCapacity = capacity.split(/([0-9.,]+)/).filter(token => token !== '');
    let unit = null;

    switch (lowerCase(splitedCapacity[1])) {
        case 'k':
            unit = 'KB';

            break;
        case 'm':
            unit = 'MB';

            break;
        case 'g':
        default:
            unit = 'GB';

            break;
    }

    return {
        capacity: +splitedCapacity[0],
        unit
    };
};

export const buildPartitionData = partitions => {
    const parsedPartitions = {};

    for (const partition of partitions) {
        const partitionData = partition.split(',');
        const parsedCapacity = parseCapacity(partitionData[1]);
        const parsedUsedPercentage = parseUsedPercentage(partitionData[4]);

        switch (partitionData[5]) {
            case '/':
                addPartition(parsedPartitions, 'system', parsedCapacity, parsedUsedPercentage);

                break;
            case '/denwa':
                addPartition(parsedPartitions, 'apps', parsedCapacity, parsedUsedPercentage);

                break;
            case '/persistent':
                addPartition(parsedPartitions, 'data', parsedCapacity, parsedUsedPercentage);

                break;
            default:
                break;
        }
    }

    return parsedPartitions;
};
